import Box from '@/components/UI/Box';
import Text from '@/components/UI/Text';
import { type FragmentOf, graphql, readFragment } from '@/gql/graphql';
import {
  EventClockFragment,
  useEventClock,
} from './EventClock/EventClock.utils';

export const EventDetailBannerClockFragment = graphql(/* GraphQL */ `
  fragment EventDetailBannerClock on event {
    event_clock {
      event_segment {
        title
      }
    }
    ...EventClock
  }
`, [EventClockFragment]);

export default function EventDetailBannerClock({
  fragment,
}: {
  fragment: FragmentOf<typeof EventDetailBannerClockFragment>;
}) {
  const clockData = readFragment(EventDetailBannerClockFragment, fragment);

  const clock = useEventClock({
    fragment: clockData,
    isDisabledExternal: true,
  });

  return (
    <Box direction="vertical" space="xs" align="center">
      <Text variant="white" px="xl" size="2xl">
        {clockData?.event_clock?.event_segment?.title}
      </Text>
      <Box direction="horizontal" align="center">
        <Text variant="white" size="3xl">
          {clock.displayMinutes}
        </Text>
        <Text variant="white" size="3xl">
          :
        </Text>
        <Text variant="white" size="3xl">
          {clock.displaySeconds}
        </Text>
      </Box>
    </Box>
  );
}
